import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { lastWeekYear, lastWeekNum } from '../helper/helper';

export function useNewsData({
                                activeAccount,
                                apiRootUrl,
                                getAccessToken,
                                selectedEntities,
                            }) {

    // Main newsletter article data and week selection state
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [selectedYear, setSelectedYear] = useState(lastWeekYear);
    const [selectedWeek, setSelectedWeek] = useState(lastWeekNum);

    // Load news data whenever week or selected entity changes
    useEffect(() => {
        const fetchNewsData = async () => {
            if (!activeAccount) return;

            const entitiesStr = Object.keys(selectedEntities)
                .filter(key => selectedEntities[key])
                .join('-');

            if (!entitiesStr) return;

            try {
                const accessToken = await getAccessToken();
                const paddedWeek = selectedWeek < 10 ? `0${selectedWeek}` : selectedWeek;

                const response = await axios.get(
                    `${apiRootUrl}/v1/data/${selectedYear}/${paddedWeek}/${entitiesStr}`,
                    {
                        headers: { Authorization: `Bearer ${accessToken}` },
                    }
                );

                setData(prev =>
                    JSON.stringify(prev) !== JSON.stringify(response.data) ? response.data : prev
                );

                setError(null);
            } catch (error) {
                console.error('Error fetching news data:', error);
                setError(error);
            }
        };

        fetchNewsData();
    }, [
        activeAccount,
        apiRootUrl,
        getAccessToken,
        selectedEntities,
        selectedWeek,
        selectedYear,
    ]);

    // Update selected year/week from dropdown value
    const handleChangeWeek = useCallback((event) => {
        const [year, week] = event.target.value.split('-');

        setSelectedYear(parseInt(year, 10));
        setSelectedWeek(parseInt(week, 10));
    }, []);

    return {
        data,
        error,
        selectedYear,
        selectedWeek,
        handleChangeWeek,
    };
}